import { render, staticRenderFns } from "./_uuid.vue?vue&type=template&id=88ac1fde&scoped=true"
import script from "./_uuid.vue?vue&type=script&lang=js"
export * from "./_uuid.vue?vue&type=script&lang=js"
import style0 from "./_uuid.vue?vue&type=style&index=0&id=88ac1fde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ac1fde",
  null
  
)

export default component.exports